import React, { useEffect } from "react";
import Navbar from "@/components/layout/Navbar";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import OrdersTab from "@/components/dashboard/OrdersTab";
import SongsTab from "@/components/dashboard/SongsTab";
import PaymentsTab from "@/components/dashboard/PaymentsTab";
import SubscriptionTab from "@/components/dashboard/SubscriptionTab";
import ProfileTab from "@/components/dashboard/ProfileTab";
import ReferralTab from "@/components/dashboard/ReferralTab";
import { useAuth } from "@/context/AuthContext";
import { useI18n } from "@/i18n/I18nContext";
import { restorePlaySubscriptions } from "@/hooks/useSubscription";
import { useToast } from "@/hooks/use-toast";
import { DASHBOARD } from "@/constants/testIds";
import SEO from "@/components/seo/SEO";

export default function Dashboard() {
  const { user } = useAuth();
  const { t } = useI18n();
  const { toast } = useToast();

  // Re-sync Google Play purchases that never finished server acknowledgement (self-guarded:
  // instant no-op outside the Android app). Referrer-based TWA detection is deliberately NOT
  // used as a gate here - it can miss on some relaunches, and a missed restore means a real
  // paid subscription gets auto-refunded by Google.
  useEffect(() => {
    restorePlaySubscriptions().then((res) => {
      if (res?.restored > 0) toast({ title: t("subscription.restoredToast") });
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main className="mx-auto max-w-5xl px-4 py-10 sm:px-6 lg:px-8">
      <SEO title="Mon espace | Kalypso Music" description="Votre tableau de bord Kalypso Music : commandes, abonnement et chansons personnalisées." path="/dashboard" noindex />
        <h1 className="font-heading text-2xl font-medium">{t("dashboard.welcomeTitle")}, {user?.name}</h1>

        <Tabs defaultValue="orders" className="mt-8">
          <TabsList className="grid h-auto w-full grid-cols-2 gap-1.5 sm:grid-cols-3 lg:grid-cols-6">
            <TabsTrigger value="orders" className="py-2" data-testid={DASHBOARD.tabOrders}>{t("dashboard.tabOrders")}</TabsTrigger>
            <TabsTrigger value="songs" className="py-2" data-testid={DASHBOARD.tabSongs}>{t("dashboard.tabSongs")}</TabsTrigger>
            <TabsTrigger value="payments" className="py-2" data-testid={DASHBOARD.tabPayments}>{t("dashboard.tabPayments")}</TabsTrigger>
            <TabsTrigger value="subscription" className="py-2" data-testid={DASHBOARD.tabSubscription}>{t("dashboard.tabSubscription")}</TabsTrigger>
            <TabsTrigger value="referral" className="py-2" data-testid={DASHBOARD.tabReferral}>{t("dashboard.tabReferral")}</TabsTrigger>
            <TabsTrigger value="profile" className="py-2" data-testid={DASHBOARD.tabProfile}>{t("dashboard.tabProfile")}</TabsTrigger>
          </TabsList>
          <TabsContent value="orders" className="mt-6"><OrdersTab /></TabsContent>
          <TabsContent value="songs" className="mt-6"><SongsTab /></TabsContent>
          <TabsContent value="payments" className="mt-6"><PaymentsTab /></TabsContent>
          <TabsContent value="subscription" className="mt-6"><SubscriptionTab /></TabsContent>
          <TabsContent value="referral" className="mt-6"><ReferralTab /></TabsContent>
          <TabsContent value="profile" className="mt-6"><ProfileTab /></TabsContent>
        </Tabs>
      </main>
    </div>
  );
}
